/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCHOpenIcon16Regular = forwardRef('ArrowCollapseCHOpenIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2.568 9.379a1.95 1.95 0 0 1 0-2.758L5.22 3.97a.75.75 0 0 1 1.06 1.06L3.63 7.682a.45.45 0 0 0 0 .636L6.28 10.97a.75.75 0 0 1-1.06 1.06L2.568 9.38Z" }),
        React.createElement("path", { d: "M13.432 9.379a1.95 1.95 0 0 0 0-2.758L10.78 3.97a.75.75 0 0 0-1.06 1.06l2.651 2.652a.45.45 0 0 1 0 .636L9.72 10.97a.75.75 0 0 0 1.06 1.06l2.652-2.651Z" })));
});
